module.exports = __webpack_public_path__ + "2ad15f3c19d30f4a596ae275d0dd2744.pdf";